import * as React from "react";
import { useParams } from "react-router-dom";
import Axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Layout from "../Layout/Layout";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  Alert,
  AlertTitle,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

async function getCallData(id) {
  try {
    let result = await Axios.get(
      `${process.env.REACT_APP_BACKEND_DOMAIN_API}/cms_catalogs/info/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
        },
      }
    );

    return result.data.data;
  } catch (error) {
    console.log(`bigc-online-catalogs: ${error}`);
  }
}

async function saveCatalog(credentials) {
  try {
    let payload = JSON.stringify(credentials);
    //console.log(payload);

    let result = await Axios.post(
      process.env.REACT_APP_BACKEND_DOMAIN_API + "/cms_catalogs/insert",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
        },
      }
    );
    return result;
  } catch (error) {
    return { message: "insert failed" };
  }
}

async function updateCatalog(credentials) {
  try {
    let payload = JSON.stringify(credentials);
    //console.log(payload);
    let result = await Axios.post(
      process.env.REACT_APP_BACKEND_DOMAIN_API + "/cms_catalogs/update",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
        },
      }
    );
    return result;
  } catch (error) {
    return { message: "update failed" };
  }
}
async function uploadPdfToCloud(file, category) {
  try {
    let payload = new FormData();
    payload.append("file", file);
    payload.append("category", category);

    let result = await Axios.post(
      process.env.REACT_APP_BACKEND_DOMAIN_API + "/uploads/catalog",
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
        },
      }
    );
    return result.data;
  } catch (error) {
    return { message: "upload failed" };
  }
}

// Must not exceed the multer limit on /uploads/catalog.
const MAX_PDF_SIZE_MB = 40;

export default function CatalogEdit() {
  const { id } = useParams();
  const [dataCatalogURL, setDataCatalogURL] = React.useState("");
  const [dataCatalogWebConnectURL, setDataCatalogWebConnectURL] =
    React.useState("");
  const [dataName, setDataName] = React.useState("");
  const [dataFriendlyUrl, setDataFriendlyUrl] = React.useState("");
  const [dataSourceFile, setDataSourceFile] = React.useState("");
  const [dataSourceName, setDataSourceName] = React.useState("");
  const [imagePaths, setImagePaths] = React.useState("");
  const [pages, setPages] = React.useState(0);

  const [dataEffectiveStartDate, setDataEffectiveStartDate] = React.useState(
    moment(new Date(), "DD/MM/YYYY HH:mm:ss")
  );
  const [dataEffectiveEndDate, setDataEffectiveEndDate] = React.useState(
    moment(new Date(), "DD/MM/YYYY HH:mm:ss")
  );
  const [dataDisplayOrder, setDataDisplayOrder] = React.useState("9999");

  const [dataStatus, setDataStatus] = React.useState(0);
  const [dataDisplayMode, setDataDisplayMode] = React.useState(1);
  const [isError, setIsError] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const [onEdit, setOnEdit] = React.useState(false);
  const [pdfFile, setPdfFile] = React.useState({
    pdfFilePreview: "/empty.jpg",
    pdfFileAsName: null,
    pdfFileAsFile: null,
  });
  const [menuItemList, setMenuItemList] = React.useState([]);
  const inputRefPdf = React.useRef(null);
  const [dataErrorTxt, setDataErrorTxt] = React.useState("");
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(async () => {
    if (id) {
      const getCatalog = await getCallData(id);

      setDataName(getCatalog.name);
      setDataFriendlyUrl(getCatalog.friendly_url);
      setDataSourceFile(getCatalog.source_file);
      setDataSourceName(getCatalog.source_name);

      setDataEffectiveStartDate(
        moment(getCatalog.effective_start_date, "DD/MM/YYYY HH:mm:ss")
      );
      setDataEffectiveEndDate(
        moment(getCatalog.effective_end_date, "DD/MM/YYYY HH:mm:ss")
      );
      if (getCatalog.display_order) {
        setDataDisplayOrder(getCatalog.display_order);
      }
      setDataStatus(getCatalog.status);
      setDataDisplayMode(getCatalog.display_mode || 1);
      setOnEdit(true);
      setPdfFile({
        pdfFilePreview: getCatalog.source_file,
        pdfFileAsName: null,
        pdfFileAsFile: null,
      });
      setDataCatalogURL(
        `${process.env.REACT_APP_WEB_DOMAIN}/catalog/${getCatalog.friendly_url}`
      );
      setDataCatalogWebConnectURL(
        `${process.env.REACT_APP_WEB_CONNECT_DOMAIN}/catalog/${getCatalog.friendly_url}`
      );

      setImagePaths(getCatalog.image_paths || []);
      setPages(getCatalog.pages || 0);
    }
  }, [id]);

  React.useEffect(async () => {
    let menuItem = [];
    for (let i = 1; i < 100; i++) {
      menuItem.push(<MenuItem value={i}>{i}</MenuItem>);
    }
    setMenuItemList(menuItem);
  }, []);

  const handleChange = (event, setTarget) => {
    event.preventDefault();
    const value = event.target.value;
    switch (setTarget) {
      case "name":
        setDataName(value);
        break;
      case "friendly_url":
        setDataFriendlyUrl(value);
        break;
      case "source_file":
        setDataSourceFile(value);
        break;
      case "source_name":
        setDataSourceName(value);
        break;
      case "effective_start_date":
        setDataEffectiveStartDate(value);
        break;
      case "effective_end_date":
        setDataEffectiveEndDate(value);
        break;
      case "display_order":
        setDataDisplayOrder(value);
        break;
      case "status":
        setDataStatus(value);
        break;
      case "display_mode":
        setDataDisplayMode(value);
        break;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //const myFile = formRef.current;
    if (
      !dataName ||
      !dataFriendlyUrl ||
      !dataEffectiveStartDate ||
      !dataEffectiveEndDate
    ) {
      setIsError(true);
      Swal.fire({
        icon: "error",
        FriendlyUrl: "Input Failed",
      });
    } else {
      setIsError(false);
      setSubmitted(true);
      setLoading(true);
      let response;
      let responseUploadPdf;
      let isSourceFile = dataSourceFile;
      let isSourceName = dataSourceName;
      let isImagePaths = imagePaths;
      let isPages = pages;

      let displayOrder = dataDisplayOrder;

      if (pdfFile.pdfFileAsFile) {
        responseUploadPdf = await uploadPdfToCloud(
          pdfFile.pdfFileAsFile,
          dataName
        );

        //console.log(responseUploadPdf);
        if (responseUploadPdf.status === "success") {
          isSourceFile = responseUploadPdf.data?.pdfUrl;
          isImagePaths = responseUploadPdf.data?.imagePaths;
          isPages = responseUploadPdf.data?.pages;
          isSourceName = pdfFile.pdfFileAsName;
        }
      }
      if (displayOrder === "default") {
        displayOrder = null;
      }

      if (id) {
        response = await updateCatalog({
          id: id,
          name: dataName,
          friendly_url: dataFriendlyUrl,
          source_file: isSourceFile,
          source_name: isSourceName,
          image_paths: isImagePaths,
          pages: isPages,

          effective_start_date: moment(dataEffectiveStartDate).format(
            "DD/MM/YYYY HH:mm:ss"
          ),
          effective_end_date: moment(dataEffectiveEndDate).format(
            "DD/MM/YYYY HH:mm:ss"
          ),
          display_order: displayOrder,
          status: dataStatus,
          display_mode: dataDisplayMode,
        });
      } else {
        response = await saveCatalog({
          name: dataName,
          friendly_url: dataFriendlyUrl,
          source_file: isSourceFile,
          source_name: isSourceName,
          image_paths: isImagePaths,
          pages: isPages,

          effective_start_date: moment(dataEffectiveStartDate).format(
            "DD/MM/YYYY HH:mm:ss"
          ),
          effective_end_date: moment(dataEffectiveEndDate).format(
            "DD/MM/YYYY HH:mm:ss"
          ),
          display_order: displayOrder,
          status: dataStatus,
          display_mode: dataDisplayMode,
        });
      }
      if (response.data.status == "success") {
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: "Success",
        }).then(() => {
          window.location.href = "/cms-catalogs";
        });
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response.data.message,
        }).then(() => {
          setSubmitted(false);
        });
      }
    }
  };

  const uploadPdf = (e) => {
    e.preventDefault();
    const targetFile = e.target.files[0];
    const targetFileName = targetFile.name;
    const resultFileName = targetFileName.substring(
      0,
      targetFileName.length - 4
    );
    const pdfUrl = URL.createObjectURL(targetFile);

    if (targetFile.type != "application/pdf") {
      //console.log("Support File Type .png, .jpg, .jpeg");
      setDataErrorTxt("Support File Type: .pdf");
      e.target.value = null;
      setDialogOpen(true);
    } else if (targetFile.size > MAX_PDF_SIZE_MB * 1024 * 1024) {
      setDataErrorTxt(`Maximum file size: ${MAX_PDF_SIZE_MB} MB`);
      e.target.value = null;
      setDialogOpen(true);
    } else {
      setPdfFile({
        pdfFilePreview: pdfUrl,
        pdfFileAsName: resultFileName,
        pdfFileAsFile: targetFile,
      });
      /*const Pdf = new Image();
      Pdf.src = pdfUrl;

      Pdf.onload = () => {
       if (Pdf.width != 600 || Pdf.height != 800) {
          //console.log("Dimensions: 600x800 px");
          setDataErrorTxt(`Support Dimensions: 600x800 px`);
          e.target.value = null;
          setDialogOpen(true);
        } else if (targetFile.size > 1048576) {
          // 1MB
          setDataErrorTxt("Maximum file size: 1MB");
          //console.log("Maximum file size: 1MB");
          e.target.value = null;
          setDialogOpen(true);
        } else {
          setPdfFile({
            pdfFilePreview: pdfUrl,
            pdfFileAsFile: targetFile,
          });
        }
        
      };*/
    }
  };
  const handleClickToUploadBox = (e) => {
    e.preventDefault();
    inputRefPdf.current.click();
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <Layout>
      <Paper sx={{ height: "100%", width: "100%" }}>
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          sx={{ minHeight: "100vh", p: 5 }}
        >
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1, width: "50ch" },
            }}
            noValidate
            autoComplete="off"
            onSubmit={(e) => handleSubmit(e)}
          >
            <h2>Catalog Form</h2>
            {dataCatalogURL ? (
              <>
                <Alert severity="info">
                  <AlertTitle>Public URL ==&gt; </AlertTitle>
                  <a href={dataCatalogURL} target="_bank">
                    <strong>online-catalog (Old) : {dataCatalogURL}</strong>
                  </a>

                  <Divider sx={{ my: 1 }} />

                  <a href={dataCatalogWebConnectURL} target="_bank">
                    <strong>
                      web-connect (New) : {dataCatalogWebConnectURL}
                    </strong>
                  </a>
                </Alert>
                <br />
              </>
            ) : (
              ""
            )}
            <TextField
              required
              fullWidth
              id="name"
              label="Name"
              value={dataName}
              error={!dataName && isError}
              onChange={(e) => handleChange(e, "name")}
            />
            <br />
            <TextField
              required
              fullWidth
              id="friendly_url"
              label="Friendly Url"
              value={dataFriendlyUrl}
              error={!dataFriendlyUrl && isError}
              onChange={(e) => handleChange(e, "friendly_url")}
            />
            <br />
            <TextField
              fullWidth
              id="upload_pdf"
              //label="image"
              //variant="outlined"
              inputRef={inputRefPdf}
              type="file"
              inputProps={{
                multiple: false,
              }}
              onChange={(e) => uploadPdf(e)}
            />
            <Card sx={{ display: "flex", maxWidth: 450, ml: 1 }}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <CardContent sx={{ flex: "1 0 auto", width: 200 }}>
                  <Typography component="div" variant="h5">
                    File Preview
                  </Typography>
                </CardContent>
              </Box>
              {pdfFile.pdfFilePreview?.endsWith(".pdf") ? (
                <Card sx={{ width: 200, border: "1px solid" }}>
                  <Box
                    component="embed"
                    src={pdfFile.pdfFilePreview}
                    type="application/pdf"
                    sx={{ width: "100%", height: 300, cursor: "pointer" }}
                    onClick={(e) => handleClickToUploadBox(e)}
                  />
                </Card>
              ) : (
                <Card sx={{ width: 200, border: "1px solid" }}>
                  <img
                    src={pdfFile.pdfFilePreview}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: 300,
                      objectFit: "contain",
                      cursor: "pointer",
                    }}
                    onClick={(e) => handleClickToUploadBox(e)}
                  />
                </Card>
              )}
            </Card>
            <br />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateTimePicker
                id="effective_start_date"
                label="Effective Start Date"
                value={dataEffectiveStartDate}
                error={!dataEffectiveStartDate && isError}
                renderInput={(params) => <TextField {...params} />}
                inputFormat="dd/MM/yyyy HH:mm"
                ampm={false}
                onChange={(newValue) => {
                  setDataEffectiveStartDate(newValue);
                }}
              />
            </LocalizationProvider>
            <br />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateTimePicker
                id="effective_end_date"
                label="Effective End Date"
                value={dataEffectiveEndDate}
                error={!dataEffectiveEndDate && isError}
                renderInput={(params) => <TextField {...params} />}
                ampm={false}
                inputFormat="dd/MM/yyyy HH:mm"
                onChange={(newValue) => {
                  setDataEffectiveEndDate(newValue);
                }}
              />
            </LocalizationProvider>
            <br />
            <TextField
              required
              select
              fullWidth
              id="display_order"
              name="display_order"
              label="Display Order"
              value={dataDisplayOrder}
              error={!dataDisplayOrder && isError}
              onChange={(e) => handleChange(e, "display_order")}
            >
              <MenuItem value="9999">Default</MenuItem>
              {menuItemList}
            </TextField>
            <br />
            <TextField
              required
              select
              fullWidth
              id="status"
              name="status"
              label="Status"
              value={dataStatus}
              error={!dataStatus && isError}
              onChange={(e) => handleChange(e, "status")}
            >
              <MenuItem value="1">Active</MenuItem>
              <MenuItem value="0">InActive</MenuItem>
            </TextField>
            <br />
            <TextField
              required
              select
              fullWidth
              id="display_mode"
              name="display_mode"
              label="Display Mode"
              value={dataDisplayMode}
              onChange={(e) => handleChange(e, "display_mode")}
            >
              <MenuItem value={1}>Mode 1 - แสดง Banner / Footer</MenuItem>
              <MenuItem value={2}>Mode 2 - ซ่อน Banner / Footer</MenuItem>
            </TextField>
            <br />
            <Button
              color="primary"
              variant="contained"
              type="submit"
              disabled={submitted}
            >
              {(submitted && "Process") || (!submitted && "Save")}
            </Button>
          </Box>
        </Grid>
      </Paper>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          flexDirection: "column",
        }}
        open={loading}
      >
        <CircularProgress color="inherit" />
        <Typography variant="h6" sx={{ mt: 2, textAlign: "center" }}>
          กำลังอัปโหลดไฟล์...
          <br />
          กรุณารอสักครู่ (ไฟล์ขนาดใหญ่ อาจใช้เวลานาน)
        </Typography>
      </Backdrop>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Error Upload Image ?
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleDialogClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            {dataErrorTxt}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Layout>
  );
}
